<template>
  <div class="input-panel panel-volume">
    <template v-if="customFacilityProfileExists">
      <form class="panel-volume__form panel-volume__row--center"
        v-show="stage === 2"
      > 
        <button class="btn mrgn-btm-0"
          :class="{ 'btn--hover' :  submitPricingRequestHover }"
          :disabled="!customFacilityProfileComplete"
          @click.prevent="getPricing"
          @mouseenter="hoverOnSubmitPricingRequest"
          @mouseleave="hoverOffSubmitPricingRequest"
          v-show="!pricingRequestStatus.length"
          ref="pricingbutton"
        >Get Pricing</button>

        <div class="mrgn-top-10" v-show="userIsLoggedIn && !pricingRequestStatus.length">
          <div class="sz-n">Inputs are Auto-Saved</div>
        </div>

        <router-link class="btn" 
          v-show="pricingRequestStatus.length"
          :to="{ name: 'PricingData' }" 
        >Display Output</router-link> 

      </form>
    </template>
    <template v-else>
      <form class="panel-volume__form panel-volume__row--center"
        v-show="stage === 1"
      >
        <div v-if="!userIsLoggedIn">
          <div class="panel-volume__terms-of-use">
            <input type="checkbox" @change="toggleTermsOfUse" id="accept-terms" value="1" required> 
            <label for="accept-terms" class="inline">I agree to the Terms of Use, which include: 
              (i) <a href="/terms-of-use/user-agreement" target="_blank" @click.prevent="showTermsOfUse('user-agreement');">User Agreement</a>, 
              (ii) <a href="/terms-of-use/privacy-policy" target="_blank" @click.prevent="showTermsOfUse('privacy-policy');">Privacy Policy</a>, and 
              (iii) <a href="/terms-of-use/cookie-policy" target="_blank" @click.prevent="showTermsOfUse('cookie-policy');">Cookie Policy</a>.
              <br>
              I also agree to the use of cookies by this website.
            </label>
          </div>

          <div 
            v-for="termsDoc in termsOfUse"
            class="modal modal-lg align-l" 
            :id="'modal-' + termsDoc.slug"
          >
            <div class="content">
              <span class="btn-close" role="button" @click="hideTermsOfUse(termsDoc.slug)"></span>
              <h2 class="hd-primary sz-i">{{ termsDoc.headline }}</h2>
              <div class="terms-of-use rich-text" v-html="termsDoc.content"></div>
              <iframe :src="'/terms-of-use/' + termsDoc.slug" style="visibility: hidden; height: 1px; width: 1px" :name="termsDoc.slug"></iframe>
              <button type="button" class="btn-secondary" @click="printTermsOfUse(termsDoc.slug)"><i class="fa fa-print"></i> Print</button>
            </div>
          </div>
        </div>
        <button class="btn mrgn-btm-0"
          :class="{ 'btn--hover' :  submitPricingRequestHover }"
          v-show="!pricingRequestStatus.length"
          @click.prevent="getPricing"
          @mouseenter="hoverOnSubmitPricingRequest"
          @mouseleave="hoverOffSubmitPricingRequest"
          :disabled="!userIsLoggedIn && !acceptedTermsOfUse"
          ref="pricingbutton"
        >Get Pricing</button>
        <div class="mrgn-top-10" v-show="userIsLoggedIn && !pricingRequestStatus.length">
          <div class="sz-n">Inputs are Auto-Saved</div>
        </div>

        <router-link class="btn" 
          v-show="pricingRequestStatus.length"
          :to="{ name: 'PricingData' }" 
        >Display Output</router-link> 

      </form>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      annualUsage: '',
      annualCost: '',
      annualPeakDemand: '',
      unit: 'usage',
      maxValue: 10000000000000,
      usageMin: 3000,
      usageMax: 4000000000,
      costMin: 1000,
      costMax: 200000000,
      peakDemandMin: 1,
      peakDemandMax: 500000,
      maxBrokerFeeDecimalPlaces: 6,
      brokerFee: '',
      stage: 1,
      termsOfUse: window.epb.termsOfUse || [],
    }
  },
  computed: {
    acceptTermsOfUse() {
      return this.$store.getters.acceptTermsOfUse
    },
    volume() {
      return this.$store.getters.pricingRequestVolume
    },
    utility() {
      return this.$store.getters.utility
    },
    customFacilityProfile() {
      return this.$store.getters.customFacilityProfile
    },
    customFacilityProfileExists() {
      return Object.keys(this.customFacilityProfile).length > 0
    },
    customFacilityProfileComplete() {
      return this.$store.getters.customFacilityProfileComplete
    },
    submitPricingRequestHover() {
      return this.$store.getters.submitPricingRequestHover
    },
    pricingRequestStatus() {
      return this.$store.getters.pricingRequestStatus
    },
    acceptedTermsOfUse() {
      return this.acceptTermsOfUse == true
    },
    userIsLoggedIn() {
      return this.$store.state.auth && 
             this.$store.state.auth.user && 
             this.$store.state.auth.user.id && 
             this.$store.state.auth.plan && 
             this.$store.state.auth.plan.slug != 'free'
    }
  },
  methods: {
    goToStage(stage) {
      this.stage = stage
    },
    hoverOnSubmitPricingRequest() {
      this.$store.dispatch('hoverOnSubmitPricingRequest')
    },
    hoverOffSubmitPricingRequest() {
      this.$store.dispatch('hoverOffSubmitPricingRequest')
    },
    focusPricingButton() {
      this.$nextTick(() => this.$refs.pricingbutton.focus())
    },
    getPricing() {

      // Click the "Get Pricing" button in the sidebar (Nav-Input.vue component).
      document.getElementById('btn-get-pricing').click()

      // Get the pricing components for the selected utility.
      // This is technically only necessary for free users since the data 
      // will already be available for subscribed users.
      this.$store.dispatch('setDashboardPricingComponents', this.utility.id)
    },
    toggleTermsOfUse(e) {
      if (e.target.checked) {
        this.$store.dispatch('acceptTermsOfUse')
      } else {
        this.$store.dispatch('declineTermsOfUse')
      }
    },
    showTermsOfUse(type) {
      document.getElementById('modal-' + type).classList.add('active')
    },
    hideTermsOfUse(type) {
      document.getElementById('modal-' + type).classList.remove('active')
    },
    printTermsOfUse(type) {
      frames[type].print()
    }
  },
  mounted() {
    if (this.customFacilityProfileExists) {
      this.goToStage(2)
    }

    this.focusPricingButton()
  }
}
</script>